module.exports = "##### App\n\nWe use these as the page background on top of which everything else is layered.\n"